import type { ObjectId } from 'mongodb';

import type { Meta } from './Entities';
import { ProgramType } from './ProgramTypes';
import { WarrantyProvider } from './Warranties';

export enum WarrantyContractSkuStatus {
  active = 'active',
  discontinued = 'discontinued',
}

export interface WarrantyContractSkuDocument {
  _id: ObjectId;
  id: ObjectId;
  warrantyProvider: WarrantyProvider;
  programType: ProgramType;
  term: number;
  contractSku: string;
  payoutAmount?: number;
  displayName?: string;
  description?: string;
  status: WarrantyContractSkuStatus;
  createdAt: Date;
  discontinuedAt?: Date;
  meta: Meta;
}

export interface WarrantyContractSkuInput {
  warrantyProvider: WarrantyProvider;
  programType: ProgramType;
  term: number;
  contractSku: string;
  payoutAmount?: number;
  displayName?: string;
  description?: string;
}
